import { getRecurrenceFrequencies } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/services/GET/getRecurrenceFrequencies"
import { useCallback, useEffect, useState } from "react"
import { findSingleCode, getChargeRecurrenceFrequencyCode } from "../../../helpers/getSingleCodeObject"
import { useAppSelector } from "@hooks/store"
import { Form } from "antd"
import { useNewEditTemplateCollectionContext } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/context/NewEditTemplateCollectionContext"
import moment from "moment"

export const useRecurrencyModal = ({ handleOpenCloseModal, isOpenModal }) => {
    //Usar un contexto tanto para traer los datos del cargo si existen como para guardarlos
    const { idToken } = useAppSelector(state => state.auth)
    const {
        chargeDetail,
        frecuencyRecurrencyOptions,
        buttonsOptions,
        setButtonsOptions,
        setChargeDetail,
        setHasUnsavedChanges,
        setFrecuencyRecurrencyOptions
    } = useNewEditTemplateCollectionContext()
    const [form] = Form.useForm()
    const [isSingleCode, setIsSingleCode] = useState("single")

    const getRecurrencyOptions = useCallback(async () => {
        const res = await getRecurrenceFrequencies({ token: idToken })
        const newData = findSingleCode(res?.data?.data, 'single')
        setButtonsOptions([
            {
                id: newData.singleObject?.frequencies[0]?.charge_recurrence_frequency_id,
                code: newData.singleObject?.frequencies[0]?.code,
                name: newData.singleObject?.name
            },
            {
                id: null,
                code: null,
                name: newData.restData?.[0].name
            }
        ])

        const defaultValues = {
            charge_recurrence_frequency_id: chargeDetail.recurrence.metadata?.charge_recurrence_frequency_id,
            issue_day: chargeDetail.recurrence.metadata?.issue_day,
            due_day: chargeDetail.recurrence.metadata?.due_day
        }
        const { charge_recurrence_frequency_code, charge_recurrence_frequency_id } = getChargeRecurrenceFrequencyCode({ defaultValues, newData })
        
        setIsSingleCode(charge_recurrence_frequency_code === 'single' ? 'single' : null)
        form.setFieldsValue({
            charge_recurrence_frequency_code,
            charge_recurrence_frequency_id,
            issue_day: defaultValues.issue_day,
            due_day: defaultValues.due_day
        })
        //Opciones para el select de recurrencia cuando no es de un cobro único
        setFrecuencyRecurrencyOptions(newData.restData?.[0].frequencies.map((item) => ({
            id: item?.charge_recurrence_frequency_id,
            name: item?.name
        })))
    }, [idToken, form, chargeDetail, setFrecuencyRecurrencyOptions, setButtonsOptions])    

    const handleChangeRecurrenceMethod = ({ code }) => {        
        setIsSingleCode(code)
        form.setFieldsValue({
            charge_recurrence_frequency_code: code,
            charge_recurrence_frequency_id: buttonsOptions.find(item => item.code === code)?.id
        })
    }

    const handleSaveRecurrence = async ({ values }) => {
        //Valores a partir del siguiente mes
        const dateValues = {
            issue_date: moment().startOf('month').add(1, 'month').add(values.issue_day, 'days').format('YYYY-MM-DD'),
            due_date: moment().startOf('month').add(1, 'month').add(values.due_day + values.issue_day, 'days').format('YYYY-MM-DD'),
        }
        setChargeDetail(prev => ({
            ...prev,
            recurrence: {
                ...prev.recurrence,
                metadata: {
                    ...prev.recurrence.metadata,
                    ...values,
                    ...dateValues
                }
            }
        }))
        setHasUnsavedChanges(true)
        //Cerrar el modal
        handleOpenCloseModal({ isOpenModal: false })
    }

    useEffect(() => {
        if (!isOpenModal) return
        getRecurrencyOptions()

    }, [getRecurrencyOptions, isOpenModal])

    return {
        form,
        frecuencyRecurrencyOptions,
        buttonsOptions,
        isSingleCode,
        handleSaveRecurrence,
        handleChangeRecurrenceMethod
    }
}